import {
    GET_ANALYSIS, 
    GET_STORY,
    GET_FULL_STORY,
    GET_STORY_CHAPTERS,
    GET_STORY_CHAPTERS_FAIL,
    REMOVE_ANALYSIS, 
    SAVED_SUCCESS, 
    SAVED_FAIL, 
    GET_SAVED_RESPONSE_SUCCESS, 
    GET_SAVED_RESPONSE_FAIL,
    GET_BOOK_SUCCESS,
    GET_BOOK_FAIL,
    POST_PLAYTIME_SUCCESS, 
    POST_PLAYTIME_FAIL,
    SAVE_LOCAL_DATA,
    GET_STORY_FAIL,
    GET_FULL_STORY_FAIL,
    GET_STORY_LENGTH,
    GET_STORY_LENGTH_FAIL,
    DELETE_STORY,
    ADD_LAZY_FLAG,
    RESET_LAZY_FLAG
} from '../../redux/constants/buddyBooks';
import { LOGOUT } from '../constants/auth';

let localAnalysisData = localStorage.getItem(`server_response`);
let segment = localAnalysisData && JSON.parse(localAnalysisData);
const initialState = {
    studentSpeech: segment || [],
    currentAnalysis: {},
    savedSession: {
        data: null,
        isSaved: false,
    },
    savedSessionResponse: {
        data: null,
        currentSection: null,
        isError: false
    },
    book: {
        data: null,
        isError: false
    },
    playTime: {
        success: true,
        error: false
    },
    localData: {
        section: null,
        isSkippedToSearch: false,
        queryText: '',
        isNotPronounced: false,
        isSkipStoryUpdated: false,
        isNextHundredStoryAdded:false
    },
    storyChapters: {},
    getStoryFail: false,
    getFullStoryFail: false,
    getStoryChaptersFail: false,
    storyLength: 0,
    lazyStoryAdded: false
}

export const analysis = (state = initialState, action) => {
    switch (action.type) {
        case GET_ANALYSIS:
            return {
                ...state,
                currentAnalysis: JSON.parse(action.speechData.analysis),
            }
        case REMOVE_ANALYSIS:
            return {
                ...state,
               currentAnalysis: []
            }
        case SAVED_SUCCESS:
            return {
                ...state,
               savedSession: {
                   data: action.payload,
                   isSaved: true,
               }
            }
        case SAVED_FAIL:
            return {
                ...state,
                savedSession: {
                    isSaved: false,
                }
            }
        case GET_SAVED_RESPONSE_SUCCESS:
            return {
                ...state,
                savedSessionResponse: {
                    data: action.payload,
                    currentSection: action.currentSection,
                    isError: false
                }
            }
        case GET_SAVED_RESPONSE_FAIL:
            return {
                ...state,
                savedSessionResponse: {
                    data: null,
                    isError: true
                }
            }
        case GET_BOOK_SUCCESS:
            return {
                ...state,
                book: {
                    data: action.payload,
                    isError: false
                }
            }
        case GET_BOOK_FAIL:
            return {
                ...state,
                book: {
                    ...state.book,
                    isError: true
                }
            }
        case POST_PLAYTIME_SUCCESS:
            return {
                ...state,
                playTime: {
                    success: true,
                    error: false
                }
            }
        case POST_PLAYTIME_FAIL:
            return {
                ...state,
                playTime: {
                    success: false,
                    error: true
                }
            }
        case SAVE_LOCAL_DATA:
            return {
                ...state,
                localData: {
                    ...state.localData,
                    isSkippedToSearch: action.isSkippedToSearch,
                    isSkipStoryUpdated: action.isSkipStoryUpdated,
                    queryText: action.queryText,
                    isNotPronounced: action.isNotPronounced,
                    isNextHundredStoryAdded : action.isNextHundredStoryAdded
                }
            }
        case GET_STORY_CHAPTERS:
            return {
                ...state,
                storyChapters: action.storyChapters
            }
        case GET_STORY_CHAPTERS_FAIL:
            return {
                ...state,
                getStoryChaptersFail: true
            }
        case GET_STORY_FAIL:
            return {
                ...state,
                getStoryFail: true
            }
        case ADD_LAZY_FLAG:
            return {
                ...state,
                lazyStoryAdded: action.payload
            }
        case RESET_LAZY_FLAG:
            return {
                ...state,
                lazyStoryAdded: action.payload
            }
        case GET_FULL_STORY_FAIL:
            return {
                ...state,
                getFullStoryFail: true
            }

        case GET_STORY_LENGTH:
            return {
                ...state,
                storyLength: action.length
            }
        case GET_STORY_LENGTH_FAIL:
            return {
                ...state,
                storyLength: 0
            }
        case LOGOUT:
            return {
                ...state,
                savedSessionResponse: {
                    data: null,
                    isError: false
                },
                book: {
                    data: null,
                    isError: false
                },
                getStoryFail: false
            }
        default:
            return state;
    }
};

export const story = (state = {}, action) => {
    switch (action.type) {
        case GET_STORY:
            return action.story;
        case DELETE_STORY:
            return {};
        case LOGOUT:
            return {}
        default:
            return state;
    }
}

export const fullStory = (state = {}, action) => {
    switch (action.type) {
        case GET_FULL_STORY:
            return action.story;
        case LOGOUT:
            return {}
        default:
            return state;
    }
}